var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaptain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FF3B3B",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 340 340",
    xmlSpace: "preserve",
    stroke: "#FF3B3B",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_852_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170,45C76.111,45,0,107.656,0,165c0,28.735,19.115,43.73,50,51.541V245c0,30,70,50,120,50s120-20,120-50v-28.459 c30.885-7.811,50-22.806,50-51.541C340,107.656,263.889,45,170,45z M140,85h60v40c0,16.568-30,30-30,30s-30-13.432-30-30V85z M290,205H50v-20h240V205z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptain);
export default __webpack_public_path__ + "static/media/captain.7ecfd4fc7d99fe47f332d586bfe7069c.svg";
export { ForwardRef as ReactComponent };